import FlavorTitle from "../components/FlavorTitle";
import FlavorSlider from "../components/FlavorSlider";

const FlavorSection = () => {
  return (
    <section id="flavors" className="flavor-section bg-[#FEF3F0]">
      <div className="flavor-track h-full flex lg:flex-row flex-col items-center bg-[#FEF3F0] relative">
        <div className="lg:w-[57%] flex-none h-auto min-h-[24vh] md:min-h-[50vh] lg:h-full md:mt-12 xl:mt-0 py-4 md:py-6 lg:py-0">
          <FlavorTitle />
        </div>
        <div className="h-full w-full bg-[#FEF3F0]">
          <FlavorSlider />
        </div>
      </div>
    </section>
  );
};

export default FlavorSection;
